import type { FormItemConfiguration } from 'components/ui/form/GenericForm/index.js';
import { z } from 'zod';

import { ReportingType } from './Helpdesk.constants.js';

export const helpdeskFormItems: FormItemConfiguration = [
  {
    config: {
      name: 'type',
      radio: true,
      options: [
        { label: 'Technical issue', value: ReportingType.TechnicalIssue },
        { label: 'Other issues', value: ReportingType.OtherIssues },
        { label: 'Suggestion', value: ReportingType.Suggestion },
      ],
    },
    validate: z.nativeEnum(ReportingType),
  },
  {
    config: {
      placeholder:
        'Describe your problem and create a new ticket in our helpdesk.',
      name: 'description',
      textarea: true,
      wrapperProps: {
        sx: { marginBottom: 5 },
      },
      inputProps: {
        'aria-label': 'Describe a problem or suggestion',
      },
    },
    validate: z
      .string()
      .min(
        10,
        'Please ensure your problem description contains at least 10 characters to provide sufficient details for us to assist you effectively.',
      ),
  },
  {
    config: {
      label: 'Include screenshot from present page',
      name: 'screenshot',
      checkbox: true,
    },
    validate: z.boolean(),
    initialValue: true,
  },
];
